export default __webpack_public_path__ + "e90e33ce4fcef906de25d8bc223b6895.svg";